import { render, staticRenderFns } from "./assignVerifier.vue?vue&type=template&id=16a19424&"
import script from "./assignVerifier.vue?vue&type=script&lang=js&"
export * from "./assignVerifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports